<template>
  <div class="autocomplete">
    <fieldset class="position-relative">
      <input
          type="text"
          class="form-control iconLeft5"
          @keyup="onChange"
          @click="onChange"
          v-bind:value="value"
          v-on:input="value= $event.target.value"
          @keydown.down="onArrowDown"
          @keydown.up="onArrowUp"
          @keydown.enter.prevent="onEnter"
          autocomplete="off"
          v-bind:placeholder="placeholder"
          v-bind:disabled="disabled"
          v-bind:class="{error:error}"
      />
      <div class="form-control-position clear-input" @click="clearValue">
        <i class="feather icon-delete " v-if="value.length"></i>
      </div>
    </fieldset>
    <div class="position-relative">
      <ul v-show="isOpen" class="autocomplete-results">
        <!--
        <li class="loading" v-if="isLoading" >
                Loading results...
              </li>
        -->
        <li class="loading text-center py-25 text-muted" v-if="(results.length<1)">
          {{ lexicon.drop_no_results }}
        </li>

        <li v-else v-for="(result, i) in results" :key="i" @click="setResult(result)"
            class="autocomplete-result" :class="{ 'is-active': i === arrowCounter }">
          {{ result.name }}
        </li>
      </ul>
    </div>
  </div>
</template>


<script>
import {mapState} from 'vuex'
export default {
  name: 'autocomplete',

  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    isAsync: {
      type: Boolean,
      required: false,
      default: false,
    },
    error: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
    },
  },

  data() {
    return {
      isOpen: false,
      results: [],
      isLoading: false,
      arrowCounter: 0,
      value: ''
    };
  },

  computed: mapState({
    lexicon: state => state.lexicon
  }),
  methods: {
    onChange() {
      if (this.isAsync) {
        this.isLoading = true;
      } else {
        // Let's  our flat array
        this.filterResults();
        this.isOpen = true;
      }
    },

    filterResults() {
      this.results = this.items.filter((item) => {
        return (item.name.toLowerCase().indexOf(this.value.trim().toLowerCase()) > -1 || item.phone.indexOf(this.value.trim().toLowerCase()) > -1)
      });
      // console.log(result)
      // this.results = Object.keys(result).sort(function(a,b){return result[a].index-result[b].index})
      // console.log(this.results)
    },
    setResult(result) {
      this.value = result.name;
      this.$emit('input', result);
      this.isOpen = false;
    },
    onArrowDown() {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },
    onEnter() {
      this.setResult(this.results[this.arrowCounter])
      this.isOpen = false;
      this.arrowCounter = -1;
    },
    clearValue() {
      this.setResult({'name': '', 'ref': ''})
      this.onChange()
    },
    handleClickOutside(evt) {
      if (!this.$el.contains(evt.target)) {
        this.isOpen = false;
        this.arrowCounter = -1;
      }
    }
  },
  watch: {
    items: function (val, oldValue) {
      if (this.disabled) {
        this.clearValue()
      }
      if (val.length !== oldValue.length) {
        this.results = val;
        this.isLoading = false;
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside)
  }
};
</script>

<style>
.autocomplete {
  position: relative;
}

.autocomplete-results {
  padding: 0;
  margin: 0;
  border: 1px solid #7367f0;
  max-height: 240px;
  overflow: auto;
  width: 100%;
  position: absolute;
  z-index: 99;
  background: #fff;
  left: 0;
  top: -1px;
  bottom: auto;
  overflow-y: scroll;
}

.autocomplete-result {
  list-style: none;
  text-align: left;
  padding: 0.25rem 0.7rem;
  cursor: pointer;
  margin-bottom: 0px;
  line-height: normal;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
  background-color: #7367f0;
  color: white;
}

.clear-input:hover {
  color: #ea5455;
  cursor: pointer;
}
</style>